module.exports = __webpack_public_path__ + "static/media/more_android.4e9ef870.svg";